import { render } from "./IoSidebar.vue?vue&type=template&id=5edad21d&ts=true"
import script from "./IoSidebar.vue?vue&type=script&lang=ts"
export * from "./IoSidebar.vue?vue&type=script&lang=ts"

import "./IoSidebar.vue?vue&type=style&index=0&id=5edad21d&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__